module.exports = "/build/web/svg/sponsor/smash-wit.88c68a3859fbb88a392487b4317be44f.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/sponsor/smash-wit.svg
// module id = 221
// module chunks = 24